import api from '../../utils/services/api';
import removeSpecialChars from '../../utils/functions/removeSpecialChars';

import {
  transfersActionError,
  transfersActionLoading,
  transfersActionSuccess,
} from '../ducks/transfers';

export const transfersFetchAction = ({
  LIMIT = 10,
  PAGE = 1,
  TIPO = '0',
  SEARCH = '',
  DATA_FIM = '',
  DATA_INICIO = '',
}) => {
  return async (dispatch) => {
    dispatch(transfersActionLoading());
    try {
      const response = await api.get(
        `/transferencias?PAGE=${PAGE}&LIMIT=${LIMIT}&DATA_INICIO=${DATA_INICIO}&DATA_FIM=${DATA_FIM}&TIPO=${TIPO}&SEARCH=${removeSpecialChars(['.', '-', '/'],
          SEARCH,
        )}`,
      );
      dispatch(transfersActionSuccess(response.data));
    } catch (error) {
      dispatch(transfersActionError());
    }
  };
};
